import { Pipe, PipeTransform }    from '@angular/core';
import { FormuleEnum }            from '@shared/enums/formule.enum';
import { isNotNull }              from '@shared/helper/LDHelper';
import { PriceFormuleParameters } from '../../components/main/oav-phase-b/preconisation/priceFormuleParameters';
import { ErrorOnFormgroup }       from '../errors/errorOnFormgroup';

const keys = ['CTT02', 'GAV', 'GLOBAL', 'OBSEQUES', 'RED02'];

@Pipe ({ standalone: true, name: 'CheckTarifPhaseBPipe' })
export class CheckTarifPhaseBPipe implements PipeTransform {
  transform (prices: PriceFormuleParameters[], formule: FormuleEnum, errorOnFormgroup: ErrorOnFormgroup): boolean {
    if (errorOnFormgroup && errorOnFormgroup.hasError) {
      return false;
    }

    const elementPrice = prices.find (c => c.formuleEnum === formule);
    let isEmpty        = true;
    if (elementPrice) {
      keys.forEach (key => {
        const mnt = elementPrice.price[key];
        if (isNotNull (mnt) && mnt !== 0) {
          isEmpty = false;
        }
      });
    }
    return isEmpty;
  }
}
